import styled from 'styled-components';
import { colors } from '../../styles/Colors';

export const TimelineContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 90%;

  @media (max-width: 650px) {
    width: 100%;
  }
`;

interface BubbleProps {
  backgroundColor?: string;
  svgColor?: string;
  margin?: string;
}

interface TextBubblePriceProps {
  red?: boolean;
  weight?: number;
  fontSize?: number;
}

export const Bubble = styled.div<BubbleProps>`
  width: 31px;
  height: 31px;
  background-color: ${(props) => props.backgroundColor ?? colors.red6};
  border-radius: 50%;
  position: inherit;
  text-align: center;
  border: 2px solid ${colors.red6};
  margin: ${(props) => props.margin}; 
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  place-self: anchor-center;
`;

export const BubbleSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-align: center;
  min-width: 70px;
`;

export const MiddleSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;

  @media (max-width: 400px) {
    flex-direction: column;
  }
`;

export const TextBubblePrice = styled.div<TextBubblePriceProps>`
  color: ${(props) => (props.red ? colors.red6 : colors.gray6)};
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0px;
  white-space: nowrap;
`;

export const NextFeeText = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: ${colors.gray6};
  text-align: center;
  line-height: 16px;

  @media (max-width: 400px) {
    font-size: 12px;
  }
`;

